module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('carousel-page', {
    attrs: {
      "type": 1
    }
  }), _vm._v(" "), _c('introduce-page', {
    attrs: {
      "type": "企业介绍",
      "url": "static/assets/images/home/01.png"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding2",
    staticStyle: {
      "background-image": "url(\"static/assets/images/service/bg.png\")",
      "background-position": "center center",
      "background-size": "cover"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row flexJCenter",
    staticStyle: {
      "margin-top": "-50px"
    }
  }, [_c('ul', {
    staticClass: "accordionWarp"
  }, _vm._l((_vm.hxList), function(item, index) {
    return _c('li', {
      class: _vm.cut == item.title ? "accordionItem accordionItemCut" : "accordionItem",
      style: (_vm.cut == item.title ? "background-image: url(static/assets/images/home/hx1" + index + ".png);" : "background-image: url(static/assets/images/home/hx0" + index + ".png);"),
      on: {
        "click": function($event) {
          return _vm.checkoutCut(item.title)
        }
      }
    }, [_c('h3', {
      staticClass: "accordionItemTitle"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "accordionItemAlt"
    }, [_vm._v(_vm._s(item.subTitle))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cut == item.title),
        expression: "cut == item.title"
      }],
      staticClass: "accordionItemText",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row BIGaccordionWarp",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, _vm._l((_vm.hxList), function(item, index) {
    return _c('div', {
      staticClass: "col-lg-3"
    }, [_c('div', {
      style: ("background-image: url(static/assets/images/home/hx1" + index + ".png);background-size:100% 100%;color: #fff;padding:40px;box-sizing: border-box;margin: 15px;")
    }, [_c('h4', {
      staticClass: "accordionItemTitle",
      staticStyle: {
        "color": "#fff"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "accordionItemAlt",
      staticStyle: {
        "color": "#fff"
      }
    }, [_vm._v(_vm._s(item.subTitle))]), _vm._v(" "), _c('div', {
      staticClass: "accordionItemText",
      staticStyle: {
        "color": "#fff"
      },
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])])
  }), 0)])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding2",
    staticStyle: {
      "background-image": "url(\"static/assets/images/home/bg.png\")",
      "background-size": "100% 100%"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 pRelative"
  }, [_c('div', {
    staticClass: "hezuohuobanWarp"
  }, _vm._l((_vm.cooperation), function(item, index) {
    return _c('img', {
      key: index,
      staticClass: "hezuohuobanItem",
      attrs: {
        "src": item.titleImage,
        "alt": item.title
      },
      on: {
        "click": function($event) {
          return _vm.imgClick(item.thirdUrl)
        }
      }
    })
  }), 0)])])])]), _vm._v(" "), _c('contact-page')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', {
    staticClass: "title borderBCD"
  }, [_vm._v("核心业务")]), _vm._v(" "), _c('p', {
    staticClass: "titleShadow"
  }, [_vm._v("CORE BUSINESS")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "feature-area section-padding2"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', {
    staticClass: "title borderBCD",
    staticStyle: {
      "z-index": "100",
      "position": "relative"
    }
  }, [_vm._v("企业优势")]), _vm._v(" "), _c('p', {
    staticClass: "titleShadow"
  }, [_vm._v("ENTERPRISE ADVANTAGE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "col-lg-4 pRelative",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "static/assets/images/home/06.png",
      "alt": "理论教学"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 pRelative",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "static/assets/images/home/07.png",
      "alt": "现场教学"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 pRelative",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "static/assets/images/home/08.png",
      "alt": "体验教学"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', {
    staticClass: "title borderBCD",
    staticStyle: {
      "z-index": "100",
      "position": "relative"
    }
  }, [_vm._v("合作伙伴")]), _vm._v(" "), _c('p', {
    staticClass: "titleShadow"
  }, [_vm._v("COOPERATIVE PARTNER")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1fe1812"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 104
// module chunks = 1